import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Case_Arrow } from "../../../../app-constants";
import { Link } from "gatsby";
import Logo9 from "../../../images/location_new/caseimg/custom-logo-1.webp";
import Img9 from "../../../images/location_new/caseimg/custom-img-1.webp";
import Logo6 from "../../../images/location_new/caseimg/custom-logo-2.webp";
import Img6 from "../../../images/location_new/caseimg/custom-img-2.webp";
import Logo3 from "../../../images/location_new/caseimg/custom-logo-3.webp";
import Img3 from "../../../images/location_new/caseimg/custom-img-3.webp";
import Logo13 from "../../../images/location_new/caseimg/custom-logo-4.webp";
import Img13 from "../../../images/location_new/caseimg/custom-img-4.webp";

const CaseStudy = [
  {
    logo: Logo9,
    title: "The Idea Behind Stock n Ship",
    description:
      "Stock n Ship, an online platform for health and fitness enthusiasts dedicated to maintaining well-being and exercise routines in the comfort of their homes.",
    link: "stock-ship",
    Img: Img9,
    BgColor: "#F4F5FF",
    TextColor: "",
  },
  {
    logo: Logo6,
    title: "The Idea Behind EquiTrip",
    description:
      "EquiTrip simplify the process of playing & engaging with fellow golf enthusiasts, offering a seamless and convenient platform, enabling you to connect with individuals sharing similar interests.",
    link: "equi-trip",
    Img: Img6,
    BgColor: "#F9F9F9",
    TextColor: "",
  },
  {
    logo: Logo3,
    title: "The Idea Behind Waste Connections",
    description:
      "An innovative solution that revolutionizes the restaurant experience, connecting customers and restaurants for seamless booking, enhanced social interaction, and efficient order processing.",
    link: "waste-connections-rmo",
    Img: Img3,
    BgColor: "#F7F7F7",
    TextColor: "",
  },
  {
    logo: Logo13,
    title: "The Idea Behind RE4 SaleSigns",
    description:
      "RE4 SaleSigns is a user-centric application that focuses on connecting individuals with nearby marijana dispensaries.",
    link: "RE4-Sale-Signs",
    Img: Img13,
    BgColor: "#FAF4FF",
    TextColor: "",
  },
];

function Stories(props) {
  return (
    <div className="section_stories p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="Success">
              <h2>
                TekRevol’s Success Stories as a Bespoke Software Development
                Company in UK
              </h2>
            </div>
            <p className="z_idx">
              Our custom software development company has revolutionized many
              businesses with its next-gen solutions that lead to multiple
              success stories. We deliver flawless products that not only meet
              the expectations of our clients but also set a trend to conduct
              business operations digitally. Here are a few glimpses of our
              famous software solutions that are well-received by businesses and
              users.{" "}
            </p>
          </Col>
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto"
              key={index}
            >
              <div
                className="stories_item web-layout"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="item_logo web-img">
                  <LazyLoadImage
                    src={item.logo}
                    effect="blur"
                    alt={item.title}
                    className="img-fluid"
                  />
                </div>
                <div className="item_tech">
                  <div className="tech_content">
                    <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                    <p>{item.description}</p>

                    <Link
                      to={
                        item.link
                          ? `/case-studies/${item.link}`
                          : "https://www.tekrevol.com/projects"
                      }
                      className="case_btn"
                      aria-label="TekRevol Contact"
                      style={{ backgroundColor: item.TextColor }}
                    >
                      View Case Study {Case_Arrow}
                    </Link>
                  </div>
                  <div className="tech_img">
                    <LazyLoadImage
                      src={item.Img}
                      effect="blur"
                      alt={item.title}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Stories;
